import { useState } from "react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Newsletter({ source = "footer" }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setStatus("sending");
        try {
            const r = await api.post("/newsletter", { email, source });
            if (r.data?.status === "already_subscribed") {
                setStatus("already");
                toast.success(t("newsletter.already"));
            } else {
                setStatus("done");
                toast.success(t("newsletter.success"));
                setEmail("");
            }
        } catch {
            setStatus("idle");
            toast.error("That email did not go through. Please try again.");
        }
    };

    return (
        <div className="border-t border-border pt-16" data-testid="newsletter-block">
            <div className="grid lg:grid-cols-12 gap-12 items-end">
                <div className="lg:col-span-6">
                    <p className="label">{t("newsletter.label")}</p>
                    <h2 className="font-serif font-light text-4xl sm:text-5xl mt-4 tracking-tight leading-[1.05]">{t("newsletter.title")}</h2>
                    <p className="prose-body mt-4 max-w-md">{t("newsletter.body")}</p>
                </div>
                <div className="lg:col-span-6">
                    <form onSubmit={submit} className="flex items-end gap-3 border-b border-border pb-3" data-testid="newsletter-form">
                        <Input
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            placeholder={t("newsletter.placeholder")} data-testid="newsletter-email"
                            className="flex-1 h-11 bg-transparent border-0 rounded-none px-0 focus-visible:ring-0 text-lg font-serif"
                        />
                        <Button type="submit" data-testid="newsletter-submit" disabled={status === "sending"}
                                className="rounded-full h-10 px-5 bg-foreground text-background hover:bg-foreground/90 text-sm">
                            {status === "sending" ? "…" : t("newsletter.submit")}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}
